export const sanitizeHtmlWithLinks = (html: string): string => {
  if (!html) return ''

  if (typeof document === 'undefined') {
    return html
      .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '') // Remove script tags
      .replace(/<[^>]*>/g, (match) => {
        if (match.match(/^<a\s+.*?href\s*=\s*["'][^"']*["'][^>]*>/i)) {
          return match.replace(/\s+(on\w+|javascript:)/gi, '') // Remove event handlers
        }
        if (match === '</a>') {
          return match
        }
        return ''
      })
  }

  const div = document.createElement('div')
  div.innerHTML = html

  const processNode = (node: Node): string => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent || ''
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as Element

      if (element.tagName.toLowerCase() === 'a') {
        const href = element.getAttribute('href')
        const textContent = element.textContent || ''

        if (href && /^(https?:\/\/|mailto:|tel:)/i.test(href)) {
          return `<a href="${href.replace(/"/g, '&quot;')}" target="_blank" rel="noopener noreferrer">${textContent}</a>`
        } else {
          return textContent
        }
      } else {
        let textContent = ''
        for (let i = 0; i < node.childNodes.length; i++) {
          textContent += processNode(node.childNodes[i])
        }
        return textContent
      }
    }

    return ''
  }

  let result = ''
  for (let i = 0; i < div.childNodes.length; i++) {
    result += processNode(div.childNodes[i])
  }

  return result
}
